import { jsx as t } from "react/jsx-runtime";
import u from "react";
import { F as c } from "./chunks/field.CyPGgOAN.js";
const d = u.forwardRef(
  ({
    id: e,
    label: o,
    caption: p,
    error: m,
    trailing: a,
    invalid: f,
    disabled: r,
    className: i,
    ...n
  }, l) => /* @__PURE__ */ t(
    c,
    {
      id: e,
      label: o,
      caption: p,
      error: m,
      trailing: a,
      invalid: f,
      disabled: r,
      className: i,
      children: /* @__PURE__ */ t("input", { ref: l, disabled: r, placeholder: "", ...n })
    }
  )
);
d.displayName = "TextInput";
export {
  d as TextInput
};
//# sourceMappingURL=text-input.js.map
